import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter
} from "@angular/core";
import {
  FileSelectDirective,
  FileDropDirective,
  FileUploader,
  FileItem,
  FileLikeObject
} from "ng2-file-upload";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import { Observable, throwError } from "rxjs";
import { ModalDirective } from "ngx-bootstrap/modal";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseAutoUploaderComponent } from "app/Core/Abstract/baseAutoUploader.component";
import { SecurityService } from "app/Core/Security/security.service";
import { ConfigService } from "app/Core/Abstract/config.service";
import { LogService } from "app/Core/Abstract/log.service";
import { VisualsService } from "app/Core/Abstract/visuals.service";
import { EventsEmitterService } from "app/Core/Abstract/emitter.service";
import { OnboardFilesService } from "./onboardfile.service";
import { BaseCRUDComponent } from "app/Core/Abstract/baseCRUD.component";

@Component({
  selector: "onboardfiles",
  templateUrl: "onboardfiles.component.html",
  providers: [OnboardFilesService]
})
export class OnboardFilesComponent extends BaseCRUDComponent<
  OnboardFilesService
> {
  @ViewChild("fileModal",{static: false}) public fileModal: ModalDirective;
  @Input() companyType: any;
  @Input() isAdmin: any;
  @Input() submit: any;
  @Input() userId: any;
  @Input() status: any;
  @Input() bean: any;
  @Input() grouErrors:any
  objectKeys = Object.keys;
  protected groupDocsList = [];
  @Output() checkValidation5Step: EventEmitter<any> = new EventEmitter<any>();
  public showFileModal(): void {
    this.fileModal.show();
  }
  public hideFileModal(): void {
    this.fileModal.hide();
  }

  constructor(
    private service: OnboardFilesService,
    private eventsEmitterService: EventsEmitterService,
    fb: FormBuilder,
    logger: LogService,
    visualsService: VisualsService,
    route: ActivatedRoute,
    router: Router
  ) {
    super(logger, visualsService, route, fb, router);
    this.group = "onboardfiles";
    this.groupDocsList = this.visualsService.getLkpFromStorageAsJSON(
      "LKP_CMP_DOC_GROUP_GENERAL_DOC_TYPE",
      true
    ); 
    this.loadVisuals();

    this.eventsEmitterService.languageChange.subscribe(langId => {
      this.loadVisuals();
      this.groupDocsList = this.visualsService.getLkpFromStorageAsJSON(
        "LKP_CMP_DOC_GROUP_GENERAL_DOC_TYPE",
        true
      ); 
    });
  }

  protected refreshView() {
    this.loadBean({});
  }
  protected loadBean(map: any) {
    this.checkValidation5Step.emit();
   }
}
